export default function OverviewTab({ stats }) {
  if (!stats) return null;
  const cards = [
    { label: "Total Users", value: stats.total_users, color: "text-sky-400", desc: stats.explanations?.total_users },
    { label: "Trees Planted", value: stats.total_trees_planted?.toLocaleString(), color: "text-emerald-400", desc: stats.explanations?.total_trees_planted },
    { label: "CO2 Absorbed", value: `${(stats.total_co2_kg / 1000).toFixed(1)}t`, color: "text-green-400", desc: stats.explanations?.total_co2_kg },
    { label: "Pending Verifications", value: stats.pending_verifications, color: "text-amber-400", desc: stats.explanations?.pending_verifications },
    { label: "Carbon Submissions", value: stats.total_carbon_submissions, color: "text-orange-400", desc: "Total carbon credit submissions received" },
    { label: "Tree Posts", value: stats.total_tree_posts, color: "text-emerald-400", desc: "Community tree planting posts with photos" },
    { label: "Active API Keys", value: stats.active_api_keys, color: "text-violet-400", desc: "Developer API keys currently active" },
  ];
  return (
    <div className="space-y-6" data-testid="admin-overview-tab">
      <div>
        <h2 className="font-heading text-xl font-semibold mb-1">System Overview</h2>
        <p className="text-xs text-stone-500 font-body">Real-time platform statistics and health metrics</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {cards.map((s) => (
          <div key={s.label} className="bg-stone-900 rounded-xl p-4 border border-stone-800 group relative"
               data-testid={`stat-${s.label.toLowerCase().replace(/\s/g, "-")}`}>
            <p className="text-[10px] text-stone-500 uppercase tracking-wider">{s.label}</p>
            <p className={`text-2xl font-heading font-bold mt-1 ${s.color}`}>{s.value}</p>
            {s.desc && <p className="text-[10px] text-stone-600 mt-1.5 font-body leading-relaxed">{s.desc}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
